const PRODUCT_ROUTE_TYPES = {
  ETF: 'etf',
  FUND: 'fund',
  MUTUAL_FUND: 'fund',
}

const normalizeProductRouteType = (value) =>
  PRODUCT_ROUTE_TYPES[
    String(value || '')
      .trim()
      .toUpperCase()
  ] || ''

const normalizeComparableProductType = (value) => {
  const normalized = String(value || '')
    .trim()
    .toUpperCase()
  return normalized === 'MUTUAL_FUND' ? 'FUND' : normalized
}

const slugifyShareClass = (value) =>
  String(value || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')

const buildProductPath = ({ ticker, productType } = {}) => {
  const routeType = normalizeProductRouteType(productType)
  const normalizedTicker = String(ticker || '')
    .trim()
    .toLowerCase()

  return routeType && normalizedTicker
    ? `/${routeType}/${normalizedTicker}`
    : ''
}

const buildAllFundPagePath = (basePath, shareClassTitle) => {
  const normalizedBasePath = String(basePath || '').replace(/\/$/, '')
  const shareClassSlug = slugifyShareClass(shareClassTitle)

  return normalizedBasePath && shareClassSlug
    ? `${normalizedBasePath}/${shareClassSlug}`
    : ''
}

const getFundClassProductType = (fundClass = {}) =>
  fundClass?.share_class?.[0]?.product_type || ''

const findProductFundClass = (
  product = {},
  preferredProductType,
  preferredShareClassTitle
) => {
  const preferredType = normalizeComparableProductType(preferredProductType)
  const preferredTitle = String(preferredShareClassTitle || '')
    .trim()
    .toLowerCase()
  const fundClasses = (product?.fund_classes || []).filter(
    (fundClass) =>
      fundClass?.ticker &&
      !fundClass?.share_class?.some(
        (shareClass) =>
          shareClass?.title?.trim().toLowerCase() === 'administrative class'
      )
  )

  return (
    fundClasses.find((fundClass) => {
      const typeMatches =
        !preferredType ||
        normalizeComparableProductType(getFundClassProductType(fundClass)) ===
          preferredType
      const titleMatches =
        !preferredTitle ||
        fundClass?.share_class?.some(
          (shareClass) =>
            shareClass?.title?.trim().toLowerCase() === preferredTitle
        )

      return typeMatches && titleMatches
    }) ||
    fundClasses.find(
      (fundClass) =>
        !preferredType ||
        normalizeComparableProductType(getFundClassProductType(fundClass)) ===
          preferredType
    ) ||
    fundClasses[0]
  )
}

const getProductPath = (
  product,
  { preferredProductType, preferredShareClassTitle } = {}
) => {
  const fundClass = findProductFundClass(
    product,
    preferredProductType,
    preferredShareClassTitle
  )

  return buildProductPath({
    ticker: fundClass?.ticker,
    productType: getFundClassProductType(fundClass),
  })
}

const getProductListingPath = ({ productType, shareClassTitle } = {}) => {
  const routeType = normalizeProductRouteType(productType)
  if (routeType === 'etf') return '/products/all/etf/'
  if (routeType === 'fund') {
    const shareClassSlug = slugifyShareClass(shareClassTitle)
    return shareClassSlug
      ? `/products/mutual-funds/overview/${shareClassSlug}/`
      : '/products/mutual-funds/overview/'
  }
  return '/products/'
}

module.exports = {
  buildAllFundPagePath,
  buildProductPath,
  findProductFundClass,
  getFundClassProductType,
  getProductListingPath,
  getProductPath,
  normalizeComparableProductType,
  normalizeProductRouteType,
  slugifyShareClass,
}
